import React from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./GamesDashboardWidget.scss";
import { map } from "lodash";
import GreenlineGameCard from "components/games/elements/GreenlineGameCard";
import { GAME_TYPES } from "constants/Games/GameConstants";

export default function GamesDashboardWidget(props) {
    const {
        basePath = "",
        clinicId = undefined,
        games= [],
        isAdminView = false,
        isProviderView = false,
        nodeId = undefined,
    } = props;
    const history = useHistory();

    const goToLeaderboard = (game) => {
        if (isAdminView) {
            history.push(`/admin/clinic/${clinicId}/games/${game.greenlineGameId}`);
        } else if(isProviderView) {
            history.push(`/provider/location/${nodeId}/clinic/${clinicId}/games/${game.greenlineGameId}`);
        } else {
            history.push(`/games/${game.greenlineGameId}`);
        }
    };

    const handleCardClick = game => {
        if (game.isAnimated) {
            goToLeaderboard(game);
        } else {
            switch (game.gameType) {
                case GAME_TYPES.ON_GARD:
                    if (isAdminView) {
                        history.push(`/admin/clinic/${clinicId}/games`);
                    } else if (isProviderView) {
                        history.push(`/provider/location/${nodeId}/clinic/${clinicId}/games`);
                    } else {
                        history.push("/games");
                    }
                    break;
                case GAME_TYPES.PUPPY_BOWL:
                case GAME_TYPES.PUPPY_POOL_PARTY:
                case GAME_TYPES.LEAF_PARTY:
                    goToLeaderboard(game);
                    break;
            }
        }
    };

    const renderGames = () => {
        if (!games) {
            return <div>No Active Games</div>;
        }

        return map(games, game => {
            return (
                <div
                    key={`game_${game.greenlineGameId}`}
                    className={styles.gameCards}
                >
                    <GreenlineGameCard
                        dashboard
                        game={game}
                        key={`game_${game.greenlineGameId}`}
                        clinicId={clinicId}
                        onCardClick={handleCardClick}
                        nodeId={nodeId}
                    />
                </div>
            );
        });
    }

    return (
        <>
            <div className="sectionHeader">
                <h3>Greenline Games</h3>
                <Link to={`${basePath}/games`} className="text-primary flex-1 text-right">
                    View all <i className="fas fa-chevron-right" />
                </Link>
            </div>
            <div className={styles.root}>
                {renderGames()}
            </div>
        </>
    );
}

GamesDashboardWidget.propTypes = {
    basePath: PropTypes.string.isRequired,
    clinicId: PropTypes.number,
    games: PropTypes.array,
    isAdminView: PropTypes.bool,
    isProviderView: PropTypes.bool,
    nodeId: PropTypes.number,
};
